import { render, staticRenderFns } from "./Lector.vue?vue&type=template&id=a80383aa"
import script from "./Lector.vue?vue&type=script&lang=js"
export * from "./Lector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports